import { useState, useEffect, useRef } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "react-bootstrap";
import { FaEye, FaEyeSlash } from 'react-icons/fa';
import "./ModifyUserPopup.css";
import { MultiSelect } from "primereact/multiselect";


const ModifyUserPopup = ({ visible, setVisible, selectedUser, onSave, updateLoading, originalVtrs, originalEmails, }) => {
  console.log("props", originalEmails)

  // inside useState
  const [formData, setFormData] = useState(() => ({
    username: selectedUser?.username || "",
    email: selectedUser?.email || "",
    password: selectedUser?.password || "",
    role:
      selectedUser?.admin === true
        ? "1"
        : selectedUser?.subAdmin === true
          ? "subAdmin"
          : "0",
    subAdmin:
      selectedUser?.admin === true
        ? false
        : selectedUser?.subAdmin === true
          ? true
          : false,
    companyName: selectedUser?.companyName || "",
    vtr: selectedUser?.vtr
      ? selectedUser.vtr.split(",").map(item => item.trim())   // ONLY selected items
      : [],  // empty by default
    information: selectedUser?.information || false,
    customerSummary: selectedUser?.customerSummary || true,
    vkPlanning: selectedUser?.vkPlanning || false,
    ekPlanning: selectedUser?.ekPlanning || false,
    template: selectedUser?.template || false,
    createUser: selectedUser?.createUser || false,
    modifyUser: selectedUser?.modifyUser || false,
  }));




  const [showPassword, setShowPassword] = useState(false);
  const [emailStatus, setEmailStatus] = useState(false);
  const [showSuggestions, setShowSuggestions] = useState(false);
  const suggestionRef = useRef(null);
  const inputRef = useRef(null);
  const itemRefs = useRef([]);
  const [highlightIndex, setHighlightIndex] = useState(-1);
  const [filteredEmails, setFilteredEmails] = useState([]);

  // const handleInputChange = (e) => {
  //   const { name, type, value, checked } = e.target;
  //   setFormData((prev) => ({
  //     ...prev,
  //     [name]: type === "checkbox" ? checked : value,
  //   }));
  // };

  const handleInputChange = (e) => {
    const { name, type, value, checked } = e.target;

    // 🔥 EMAIL FILTER LOGIC
    if (name === "email") {
      setFormData((prev) => ({
        ...prev,
        email: value,
      }));

      const filtered = originalEmails.filter((item) =>
        item.toLowerCase().includes(value.toLowerCase())
      );

      setFilteredEmails(filtered);
      setEmailStatus(true);
      setHighlightIndex(-1);
      return;
    }

    // 🔥 ROLE CHANGE LOGIC (same as yours)
    if (name === "role") {
      if (value === "1") {
        // ADMIN
        setFormData((prev) => ({
          ...prev,
          role: value,
          subAdmin: false,
          information: true,
          customerSummary: true,
          vkPlanning: true,
          ekPlanning: true,
          template: true,
          createUser: true,
          modifyUser: true,
        }));
      }

      else if (value === "0") {
        // USER
        setFormData((prev) => ({
          ...prev,
          role: value,
          subAdmin: false,
          information: false,
          customerSummary: true,
          vkPlanning: true,
          ekPlanning: true,
          template: true,
          createUser: false,
          modifyUser: false,
        }));
      }

      else if (value === "subAdmin") {
        // SUB ADMIN
        setFormData((prev) => ({
          ...prev,
          role: value,
          subAdmin: true,
          information: true,
          customerSummary: true,
          vkPlanning: true,
          ekPlanning: true,
          template: true,
          createUser: false,
          modifyUser: false,
        }));
      }

      return;
    }

    // 🔥 NORMAL INPUT (checkbox + text)
    setFormData((prev) => ({
      ...prev,
      [name]: type === "checkbox" ? checked : value,
    }));
  };
  // multi vtr function 
  const handleVtrChange = (e) => {
    setFormData({
      ...formData,
      vtr: e.value.join(","), // ✅ store as string
    });
  };

  // Convert VTR list to PrimeReact MultiSelect format
  const vtrOptions = originalVtrs.map((item) => ({
    label: item,
    value: item,
  }));


  const handleSave = () => {
    onSave(formData); // Pass back to parent
    // setVisible(false); // Close modal
  };


  // Email code Funtion
  const checkEmailSuggestion = () => {
    setEmailStatus((pre) => !pre)
    console.log("emailStatus>>>", emailStatus)
    setFilteredEmails(originalEmails);
  }

  const closeDialogBox = () => {
    setVisible(false)
  }

  // Hide dropdown on outside click
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        suggestionRef.current &&
        !suggestionRef.current.contains(event.target) &&
        inputRef.current &&
        !inputRef.current.contains(event.target)
      ) {
        setEmailStatus(false);
      }
    };

    document.addEventListener("click", handleClickOutside);
    return () => document.removeEventListener("click", handleClickOutside);
  }, []);

  const handleSelectEmail = (email) => {
    setFormData((prev) => ({
      ...prev,
      email: email,
    }))
    setEmailStatus(false);
  }

  const scrollToItem = (index) => {
    const element = itemRefs.current[index];
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        black: "nearest",
      })
    }
  };

  const handleKeyDown = (e) => {
    if (!emailStatus) return;

    switch (e.key) {
      case "ArrowDown":
        e.preventDefault();
        setHighlightIndex((prev) => {
          const next =
            prev < originalEmails.length - 1 ? prev + 1 : 0;

          setTimeout(() => scrollToItem(next), 0);
          return next;
        });
        break;

      case "ArrowUp":
        e.preventDefault();
        setHighlightIndex((prev) => {
          const next =
            prev > 0 ? prev - 1 : originalEmails.length - 1;

          setTimeout(() => scrollToItem(next), 0);
          return next;
        });
        break;

      case "Enter":
        e.preventDefault();
        if (highlightIndex >= 0) {
          handleSelectEmail(originalEmails[highlightIndex]);
        }
        break;

      default:
        break;
    }
  };



  return (
    <>
      <Dialog
        header="Modify User"
        className="popup_box"
        visible={visible}
        onHide={() => { closeDialogBox() }}
        style={{ width: "500px" }}
        headerStyle={{
          // border: "2px solid red",
          padding: "2px",
          textAlign: "center",
          color: "darkred",
          // backgroundColor:"#fff3cd"
        }}
      >
        <div className="modify_form_container">

          <div className="modify_form_input_main">
            {/* UserName */}
            <div className="Modify_form_input">
              <label className="lable_check">Username</label>
              <input
                type="text"
                name="username"
                className="form-control"
                value={formData.username}
                onChange={handleInputChange}
                maxLength={15}
                placeholder="username"
                autoComplete="off"
              />
            </div>
            {/* Password */}
            <div className="Modify_form_input" style={{ position: "relative" }}>
              <label className="lable_check">Password</label>
              <input
                type={showPassword ? "text" : "password"}
                name="password"
                className="form-control"
                value={formData.password}
                onChange={handleInputChange}
                placeholder="password"
                style={{ paddingRight: "40px" }}
              />
              <button
                type="button"
                onClick={() => setShowPassword((prev) => !prev)}
                style={{
                  position: "absolute",
                  right: "24px",
                  top: "68%",
                  transform: "translateY(-50%)",
                  background: "none",
                  border: "none",
                  cursor: "pointer",
                }}
              >
                {showPassword ? <FaEyeSlash /> : <FaEye />}
              </button>
            </div>

          </div>

          <div className="modify_form_input_main">
            {/* CompanyName */}
            <div className="Modify_form_input">
              <label className="lable_check">Company Name</label>
              <input
                type="text"
                name="companyName"
                className="form-control role_option"
                value={formData.companyName}
                onChange={handleInputChange}
              />
            </div>
            {/* Email */}
            <div className="Modify_form_input">
              <label className="lable_check">Email</label>
              <input
                ref={inputRef}
                type="email"
                name="email"
                className="form-control emial_input"
                value={formData.email}
                onChange={handleInputChange}
                onClick={checkEmailSuggestion}
                onKeyDown={handleKeyDown}
                autoComplete="off"
              />
            </div>
            {emailStatus && filteredEmails.length > 0 && (
              <div className="suggestion_boxModifyUserPopup" ref={suggestionRef}>
                <ul className="suggestion_listModifyUserPopup">
                  <div
                    className={"email-mainModifyUserPopup"}
                  >
                    {filteredEmails.map((item, index) => (
                      <li
                        key={index}
                        ref={(el) => (itemRefs.current[index] = el)}
                        onClick={() => handleSelectEmail(item)}
                        className={`emial_list ${highlightIndex === index ? "active_email" : ""}`}
                      >
                        {item}
                      </li>
                    ))}
                  </div>
                </ul>
              </div>
            )}
          </div>

          <div className="modify_form_input_main">
            {/* Role */}
            <div className="Modify_form_input">
              <label className="lable_check">Role</label>
              <select
                name="role"
                className="form-control role_option"
                value={formData.role}
                onChange={handleInputChange}
                style={{ cursor: "pointer" }}
              >
                <option value="1" className="role_option">Admin</option>
                <option value="0">User</option>
                <option value="subAdmin">Sub Admin</option>
              </select>
            </div>
            {/* VTR */}
            {formData.role === "subAdmin" && formData.subAdmin && (

              <div className="Modify_form_input">
                <label className="lable_check">VTR</label>
                <MultiSelect
                  value={formData.vtr}  // ALWAYS ARRAY
                  options={vtrOptions}
                  onChange={(e) =>
                    setFormData({
                      ...formData,
                      vtr: e.value,   // KEEP ARRAY
                    })
                  }
                  placeholder="Select VTR"
                  filter
                  className=" flex items-center border border-gray-300 rounded-md h-[40px] px-2 form-control custom-multiselect"
                  maxSelectedLabels={4}
                />

              </div>
            )}
          </div>


          <div className="input1_main">
            <div className="input1_checkbox">
              {/* Information */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-information"
                  name="information"
                  checked={formData.information}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-information">
                  Information
                </label>
              </div>

              {/* VK Planning */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-vkPlanning"
                  name="vkPlanning"
                  checked={formData.vkPlanning}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-vkPlanning">
                  VK Planning
                </label>
              </div>

              {/* CreateUser */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-createUser"
                  name="createUser"
                  checked={formData.createUser}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-createUser">
                  CreateUser
                </label>
              </div>


              {/* ModifyUser */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-modifyUser"
                  name="modifyUser"
                  checked={formData.modifyUser}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-modifyUser">
                  ModifyUser
                </label>
              </div>
            </div>

            <div className="input1_checkbox">
              {/* CustomerSummary */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-customerSummary"
                  name="customerSummary"
                  // checked={formData.customerSummary}
                  checked={true}
                  onChange={handleInputChange}
                // disabled
                />
                <label className="form-check-label" htmlFor="check-customerSummary">
                  CustomerSummary
                </label>
              </div>

              {/* EK Planning */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-ekPlanning"
                  name="ekPlanning"
                  checked={formData.ekPlanning}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-ekPlanning">
                  EK Planning
                </label>
              </div>

              {/* Template */}
              <div className="form-check">
                <input
                  className="form-check-input"
                  type="checkbox"
                  id="check-template"
                  name="template"
                  checked={formData.template}
                  onChange={handleInputChange}
                />
                <label className="form-check-label" htmlFor="check-template">
                  Template
                </label>
              </div>


            </div>
          </div>





          <div
            className="popup_actions"
            style={{
              padding: "10px",
              display: "flex",
              justifyContent: "space-evenly",
              alignItems: "center"
            }}
          >
            <Button
              variant="secondary"
              onClick={() => setVisible(false)}
              style={{ marginRight: "10px" }}
            >
              Cancel
            </Button>
            <Button
              variant="success"
              onClick={handleSave}
              disabled={updateLoading}
              style={{
                width: "70px",
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}>
              {updateLoading ? (
                <div id="loading_both">
                  <i id="spinner" className="fa fa-spinner fa-spin"></i>{" "}
                </div>
              ) : (
                "Save"
              )}
            </Button>
          </div>
        </div>
      </Dialog>
    </>
  );
};

export default ModifyUserPopup;
